import getAvailableSearchCriteria from './getAvailableSearchCriteria';
import getNewspapersForDate from './getNewspapersForDate';
import getNewspaperByPublicationIdAndDate from './getNewspaperByPublicationIdAndDate';
import getNewspapersByMonthAndPublication from './getNewspapersByMonthAndPublication';
export default {
    getAvailableSearchCriteria: getAvailableSearchCriteria,
    getNewspapersForDate: getNewspapersForDate,
    getNewspaperByPublicationIdAndDate: getNewspaperByPublicationIdAndDate,
    getNewspapersByMonthAndPublication: getNewspapersByMonthAndPublication,
};
